<div class="app">
    <mat-sidenav-container class="container">
        <mat-sidenav #sidenav [ngClass]="['sidenav', size()]" [mode]="'over'" (backdropClick)="onClose()">
            <app-side></app-side>
        </mat-sidenav>
        <mat-sidenav-content class="content">
            <div class="page">
                <div class="page-head">
                    <app-head></app-head>
                </div>
                <div class="page-menu">
                    <app-menu></app-menu>
                    <app-cart></app-cart>
                </div>
                <div class="page-body">
                    <app-page></app-page>
                    <div class="body-foot"></div>
                    <app-chat></app-chat>
                </div>
                <div class="page-foot">
                    <app-foot class="foot"></app-foot>
                </div>
            </div>
            <div class="copyright">
                <span class="logo"><img src="/assets/image/logo-mando-black.svg"></span>
                <span class="label">Copyright © Mando {{year}}, All Rights Reserved</span>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
    <div class="page-note">
        <app-note></app-note>
    </div>
    <div class="page-film">
        <app-film></app-film>
    </div>
</div>
